import getFollowPageFollowingCount from "./getFollowPageFollowingCount";

/**
 * Hook: 获取基于 AB 测试的首页 URL（自动获取 AB 实验值）
 *
 * @param {Object} user 用户信息
 * @param {Object} [options] 配置选项
 * @param {boolean} [options.allowHome=true] 是否允许返回首页"/"，false时无用户会返回"/discovery"
 * @returns {string} 目标路由路径："/", "/discovery"
 */
export function useHomeUrl(user, options = {}) {
  const { allowHome = true } = options;

  // 如果没有用户信息，根据 allowHome 选项决定返回值
  if (!user) {
    return allowHome ? "/" : "/discovery";
  }

  // 实验结果直接返回发现页
  return "/discovery";
}

/**
 * 检查用户是否应该跳转到关注页（用于引导页等场景）
 *
 * @param {Object} user 用户信息
 * @returns {boolean} 是否应该跳转到关注页
 */
export function shouldGoToFollowPage(user) {
  if (!user) {
    return false;
  }

  const effectiveFollowingCount = getFollowPageFollowingCount(user);
  return effectiveFollowingCount > 0;
}
